<template>
  <Select
    v-model="selectedTags"
    filterable
    clearable
    :multiple="multiple"
    @change="onChange"
  >
    <Option :value="t.id" :key="`hrmta_${t.id}`" v-for="t in types" :label="t.s1">{{ t.s1 }}
    </Option>
  </Select>
</template>

<script>
// import { getGroupInUsers } from "@/api/modules/sys/group";
//import { getData } from "@/api/type";
import { request } from "@/api/all";
// import { TagIcon } from 'vue-feather-icons';
import "element-ui/lib/theme-chalk/index.css";
import { Select, Option } from "element-ui";
import { mapActions } from "vuex";

export default {
  components: { Select, Option },
  name: "hrmTagAssign",
  props: {
    editKey: {
      type: String,
      default: () => "138"
    },
    fld: {
      type: String,
      default: () => ""
    },
    multiple:
    {
      type: Boolean,
      default: () => true
    },
  },
  data() {
    return {
      selectedTags: null,
      types: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["getGroupDefaultProjects"]),
    init() {
      let self = this;

      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == self.editKey
      );
      if (prjs.length > 0) {
        let _key = "sysProjectTag_" + prjs[0].id;
        request({
          api: { url: "type/getData", method: "get" },

          params: { key: _key, getParentType: true },
          store: self.$store
        }).then(res => {
          //console.log("4");
          this.types = res.data.types;
          //console.log('self.fld', self.fld);
          this.selectedTags = self.fld != null ? self.fld.split(",").map(Number) : null;
        });
      }
    },
    onChange(e) {
      //console.log(e.toString());
      this.$emit("input", e.toString());
      this.$emit("on-change", e.toString());
    }
  }
};
</script>
